<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="60"
    >
      <FormItem label="名称" prop="action_name">
        <Input v-model="formValidate.action_name" placeholder="请输入名称"></Input>
      </FormItem>

      <FormItem label="值" prop="action_value">
        <Input v-model="formValidate.action_value" placeholder="请输入值" type="number"></Input>
      </FormItem>
      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formValidate: {
        id: '',
        action_name: '',
        action_value:''
      },
      ruleValidate: {
        action_name: [
          {
            required: true,
            message: '名称不能为空',
            trigger: 'blur'
          }
        ],   action_value: [
          {
            required: true,
            message: '值不能为空',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    setEditData (editData) {
      this.formValidate.id = editData.id
      this.formValidate.action_name = editData.name
      this.formValidate.action_value = editData.value.toString()
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
    
  }
}
</script>
